import {IconButton, Tooltip, useTranslationContext} from 'platform/components';
import {match} from 'ts-pattern';

import {useMemo} from 'react';

import {suffixTestId} from 'shared/web';

import {ToolpanelToggleRendererProps} from '../types/ToolpanelToggleRenderer';
import {ToolpanelType} from '../types/ToolpanelType';

export function ToolpanelToggleRenderer(props: ToolpanelToggleRendererProps) {
  const t = useTranslationContext();

  const label = match(props.toolpanel)
    .with(ToolpanelType.filter, () => t('page.datagrid.labels.filters'))
    .with(ToolpanelType.settings, () => t('page.datagrid.labels.settings'))
    .with(ToolpanelType.column, () => t('page.datagrid.labels.columnSetting'))
    .otherwise(() => null);

  const icon = useMemo(() => {
    if (props.toolpanel === ToolpanelType.filter) {
      return 'content/filter_list';
    }
    if (props.toolpanel === ToolpanelType.settings) {
      return 'action/settings';
    }
    if (props.toolpanel === ToolpanelType.column) {
      return 'editor/table_chart';
    }
    return null;
  }, [props.toolpanel]);

  if (!icon || !label) {
    return null;
  }

  return (
    <Tooltip placement="left" label={label}>
      <IconButton
        onClick={props.toggleToolpanel}
        priority={
          props.hasActiveFilter && props.toolpanel === ToolpanelType.filter ? 'primary' : undefined
        }
        data-testid={suffixTestId(props.toolpanel.toString(), props)}
        icon={icon}
      />
    </Tooltip>
  );
}
